import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaginationDTO } from "../../dtos/manufacturer";
import { AddSupplierDTO } from "../../dtos/supplier";
import SupplierService from "./supplierService";

// Define initial state
const initialState = {
  supplierDetails: [],
  supplierId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: <any>"",




  isSupplierLoading: false,


 
  isSupplierLoadingError: false,
};



export const AddSupplier = createAsyncThunk(
  "/api/pharmacy/supplier/add",
  async (supplier: AddSupplierDTO, thunkAPI) => {
    try {
      return await SupplierService.AddSupplier(supplier);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getSupplierData = createAsyncThunk(
  "supplier/getSupplierData", // Action type prefix
  async ({ pharmacy_id, dto }: { pharmacy_id: any; dto?: PaginationDTO }, thunkAPI) => {
    try {
      const response = await SupplierService.getSupplier(pharmacy_id, dto); // Call the function
      return response.data; 
    } catch (error :any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getSupplierBatchesData = createAsyncThunk(
  "supplier/getSupplierBatchesData", // Action type prefix
  async ({ pharmacy_id, supplier_id } : any, thunkAPI) => {
    try {
      const response = await SupplierService.getSupplierBatches( pharmacy_id,
        supplier_id); // Call the function
      return response.data; 
    } catch (error :any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const editSupplier = createAsyncThunk(
  "supplier/edit",
  async (supplier: AddSupplierDTO, thunkAPI) => {
    try {
      return await SupplierService.editSupplier(supplier);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const supplierSlice = createSlice({
  name: "supplierSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeSupplierId: (state, action) => {
      state.supplierId = action.payload.supplier;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getSupplierData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSupplierData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.supplierDetails = action.payload.supplier;
        state.message = "";
      })
      .addCase(getSupplierData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      
  },
});

// Export actions and reducer
export const { reset, changeSupplierId } = supplierSlice.actions;
export default supplierSlice.reducer;
